export const MAX_VALUES = {
  RATE_HOUR: 99999,
  RATE_DAY: 999999,
  HOURS: 9999,
  PRICE: 10000000,
  UNIT_PRICE: 999999,
}